import { Component, OnInit, Input, inject, signal } from '@angular/core';
import moment, { Moment } from 'moment';

import { Router, RouterModule } from '@angular/router';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { FlowItemModel } from '../../../shared/models/FlowItemModel';
import { ScoutingService } from '../../../shared/services/scouting.service';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../material/material.module';
import { ReportOverallGradesComponent } from '../report-overall-grades/report-overall-grades.component';
import { TranslateModule } from '@ngx-translate/core';
import { ReportDetailsDialogComponent } from '../report-details-dialog/report-details-dialog.component';
import { MatCardModule } from '@angular/material/card';




@Component({
    selector: 'app-report-card',
    imports: [CommonModule, TranslateModule, MaterialModule, RouterModule, ReportOverallGradesComponent, MatCardModule],
    templateUrl: './report-card.component.html',
    styleUrls: ['./report-card.component.css']
})
export class ReportCardComponent implements OnInit {

  borderColors: string[] = ['grayshading', 'redshading', 'yellowshading', 'yellowshading', 'greenshading', 'greenshading', 'greenshading', 'greenshading'];

  @Input() Report: FlowItemModel;
  dialog = inject(MatDialog);

  private static readonly TEXT_PREVIEW_LENGTH = 400;
  private static readonly TEXT_TRUNCATE_THRESHOLD = 500;

  isTextExpanded = signal(false);

  get isTextTruncated(): boolean {
    return (this.Report?.Text?.length ?? 0) > ReportCardComponent.TEXT_TRUNCATE_THRESHOLD;
  }

  get displayText(): string {
    const text = this.Report?.Text ?? '';
    if (!this.isTextTruncated || this.isTextExpanded()) {
      return text;
    }
    return text.slice(0, ReportCardComponent.TEXT_PREVIEW_LENGTH) + '...';
  }

  toggleTextExpanded(event: MouseEvent) {
    event.stopPropagation();
    this.isTextExpanded.update(expanded => !expanded);
  }

  getTimeAgo(){
    moment.locale(localStorage.getItem("language")?.substring(0, 2) ?? 'en');
    return moment(this.Report.DateCreated).fromNow();
  }

  constructor(public _router: Router, public matDialog: MatDialog, public scoutingService: ScoutingService) { }

  ngOnInit() {
  }

  gotoPlayerDetails(playerid: string){
    this._router.navigateByUrl('/player/details/' + playerid );

  }

  gotoReportDetails(reportId: string) {
    const dialogRef = this.dialog.open(ReportDetailsDialogComponent, {
      width: '100vw',
      maxWidth: '100vw',
      height: '100dvh',
      maxHeight: '100dvh',
      hasBackdrop: false,
      data: {
        ReportId: this.Report.ReportId,
      }

    });
  }

  gotoPlayerDashboard(){
    this._router.navigateByUrl('/scouting/playertotalview');

  }



  deleteReport(report: FlowItemModel){
    // console.log(report);
    //this.scoutingService.addReport
  }
  

  setClass(){
    
    if (this.Report.TotalQuality >= 4) {
      return 'greenborder';
    }
    if (this.Report.TotalQuality >= 2) {
      return 'yellowborder';
    }
    if (this.Report.TotalQuality >= 1) {
      return 'redborder';
    }
    return '';
  }

    openReportDetails() {
    const dialogRef = this.dialog.open(ReportDetailsDialogComponent, {
       width: '100vw',
      maxWidth: '450px',
      height: '100dvh',
      maxHeight: '100dvh',
      
       panelClass: 'side-dialog',
      position: {
        right: '0'
      },
      data: {
        ReportId: this.Report?.ReportId,
        CanEdit: this.Report?.IsCreatedByCurrentUser       
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log(`Dialog result: ${result}`);
    });
    }



}
